function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.667 5.334H22.44L20 2.667h-8L9.56 5.334H5.334A2.675 2.675 0 002.667 8v16a2.675 2.675 0 002.667 2.667h21.333A2.675 2.675 0 0029.334 24V8a2.675 2.675 0 00-2.667-2.666zm0 18.667H5.334v-16h5.4l2.44-2.667h5.653L21.267 8h5.4zM16 9.334A6.667 6.667 0 1022.667 16 6.669 6.669 0 0016 9.334zm0 10.667a4 4 0 114-4A4.012 4.012 0 0116 20z",
  fill: "#fff"
});

var SvgCameraAlt24Px = function SvgCameraAlt24Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCameraAlt24Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera_alt-24px.18a7cdae.svg";
export { ForwardRef as ReactComponent };